export default {
  Post: {
    PublishDate: 'Ngày đăng: {date}',
    PostDetailTitle: 'Chi tiết tin tuyển sinh',
  },

  SchoolPortal: {
    EnrollmentPost: 'Tin tuyển sinh',
    ChooseEnrollSchoolLevel: 'Chọn cấp tuyển sinh',
    SearchProfile: 'Tra cứu hồ sơ',
    SearchProfileDescription: 'Nhập số điện thoại và ngày sinh của con để tra cứu hồ sơ',
  },
}
